import { render } from "./TemplatesTableRow.vue?vue&type=template&id=8b96c37a"
import script from "./TemplatesTableRow.vue?vue&type=script&lang=js"
export * from "./TemplatesTableRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__